import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import styles from './Sliders.module.scss'
import { Spin } from 'antd'
import SubjectCategories from './components/SubjectCategories/SubjectCategories'
import SliderItems from './components/SliderItems/SliderItems'

function Sliders() {
  const isLoaded = useSelector(state => state.slider.isLoaded)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch({type: 'SET_MENU_KEY', key: 'menu', data: [
      {title: 'mn_dashboard', url: '/dashboard'}
    ]})
    return () => {
      dispatch({type: 'SET_MENU_KEY', key: 'menu', data: []})
    };
  }, [])

  return (
    <div className={styles.Sliders}>
      {!isLoaded && <div className={styles.spinner}>
        <Spin size='large'/>
      </div>}
      <div className='row'>
        <div className='col-md-4'>
          <SubjectCategories />
        </div>
        <div className='col-md-8'>
          <SliderItems />
        </div>
      </div>
    </div>
  )
}

export default Sliders